function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 3a1 1 0 00-1 1v5h2V5h4V3H4zm12 0h-1v2h4v4h2V4a1 1 0 00-1-1h-4zM5 16v-1H3v5a1 1 0 001 1h5v-2H5v-3zm16 0v-1h-2v4h-4v2h5a1 1 0 001-1v-4zm-6-7H9v6h6V9z",
  fill: "currentColor"
});

function SvgCenter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDNDMy40NDc3MiAzIDMgMy40NDc3MiAzIDRMMyA4TDMgOUg1TDUgOEw1IDVIOEg5VjNIOEg0Wk0xNiAzSDE1VjVIMTZIMTlMMTkgOFY5TDIxIDlWOEwyMSA0QzIxIDMuNzM0NzggMjAuODk0NiAzLjQ4MDQzIDIwLjcwNzEgMy4yOTI4OUMyMC41MTk2IDMuMTA1MzYgMjAuMjY1MiAzIDIwIDNIMTZaTTUgMTZWMTVIM1YxNlYyMEMzIDIwLjU1MjMgMy40NDc3MiAyMSA0IDIxSDhIOVYxOUg4SDVWMTZaTTIxIDE2VjE1SDE5VjE2TDE5IDE5SDE2SDE1VjIxSDE2SDIwQzIwLjU1MjMgMjEgMjEgMjAuNTUyMyAyMSAyMEwyMSAxNlpNMTUgOUg5VjE1SDE1VjlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };